<script lang="ts" setup>
import type { Housing } from '~/models/Housing';

const { showToast } = useToast();
const { t } = useI18n();

defineProps({
  housing: {
    type: Object as PropType<Housing>,
    required: true,
  },
});

defineOptions({
  inheritAttrs: false,
});

const modalOpen = ref(false);

function open() {
  modalOpen.value = true;
}

function onReported() {
  showToast('success', t('report.success'), t('report.alert_success'), 4500);
}
</script>

<template>
  <slot name="button" :open="open" :is-open="modalOpen" :on-reported="onReported">
    <TwUiAction :is="'button'" type="button" variant="text" class="button" @click="open" v-bind="$attrs">
      <slot>
        <Icon name="bi:exclamation-triangle" />
        {{ $t('to-report') }}
      </slot>
      <tw-report-housing-card-modal :housing="housing" :state="modalOpen" @close="modalOpen = false" @reported="onReported" />
    </TwUiAction>
  </slot>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/tw-form.scss';

.button {
  gap: 0.5rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  text-transform: uppercase;
}
</style>
